import { useSelector } from "react-redux";

import {
  selectPrimaryInsuranceCarrier,
  selectSelfAcpConsentResponse,
} from "@/redux/selectors/patientSelectors";

import { getACPStatus } from "../helpers/getACPStatus";
import type { ACPStatus } from "../types/acp";

export function useACPStatus(): ACPStatus {
  const consentResponse = useSelector(selectSelfAcpConsentResponse);
  const insuranceCarrier = useSelector(selectPrimaryInsuranceCarrier);

  return getACPStatus({
    consentResponse,
    insuranceCarrier,
  });
}
